import { gql } from 'graphql.macro';

export const getIntegrationApiModesTemplate = gql`
    query integrationApiModes {
        integrationApiModes {
            server
            vendors {
                vendor
                mode
                realConfigured
            }
        }
    }
`;

export const setIntegrationApiModeTemplate = gql`
    mutation setIntegrationApiMode($server: IntegrationMockServer!, $mode: IntegrationApiMode!) {
        setIntegrationApiMode(server: $server, mode: $mode) {
            server
            vendors {
                vendor
                mode
                realConfigured
            }
        }
    }
`;
